export default __webpack_public_path__ + "static/media/fw-adele-er-White Gold.ee3e3b3f.mp4";